import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';
const isRenderingOnServer: boolean = typeof window === 'undefined';

const getInitialState: () => boolean = (): boolean => {
    return isRenderingOnServer ? true : !window.matchMedia(QUERY).matches;
};

export function usePrefersReducedMotion(): boolean {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(
        getInitialState()
    );

    useEffect(() => {
        const mediaQueryList: MediaQueryList = window.matchMedia(QUERY);

        // addEventListener isn't supported on older implementations of
        // matchMedia
        if (!mediaQueryList.addEventListener) {
            return;
        }

        const listener: (event: MediaQueryListEvent) => void = (
            event: MediaQueryListEvent
        ) => {
            setPrefersReducedMotion(!event.matches);
        };

        mediaQueryList.addEventListener('change', listener);

        return () => {
            mediaQueryList.removeEventListener('change', listener);
        };
    }, []);

    return prefersReducedMotion;
}
